import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import React, { useEffect, useState } from 'react';
import { motion } from "framer-motion";
import { NavLink } from 'react-router-dom';
import { getLocalizedText } from '../utils/textLocalization';
import zaruka from '../images/zaruka.jpg';
import builder from '../utils/builderWithLocale';


function App() {
  const bikesText = getLocalizedText('general.bikes_caps');
  const [data, setData] = useState([]);

  const registerBike = getLocalizedText('warranty.register');

  const handleScroll = (e) => {
    const hash = e.currentTarget.hash.substring(1);
    setTimeout(() => {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  useEffect(() => {
    builder.get("prodlouzena-zaruka").then(res => {
      setData(res.data);
    })
  }, [])

  if (!data) return (
    <div className="page">

    </div>
  )

  return (
    <div className="page">
        <div className="cesta-novinky cesta-zaruka">
          <NavLink to="/#kola" onClick={handleScroll}><button><span>{bikesText}</span></button></NavLink>
          <button className="cesta-active"><span>{data.nadpis}</span></button>
        </div>

        <div className="zaruka-obsah">
            <img src={data.obrazek} alt={data.nadpis}/>
            <h1>{data.nadpis}</h1>
            <p><div dangerouslySetInnerHTML={{ __html: data.text }}></div></p>
            <NavLink to={data.cudlik}><button><span>{registerBike}</span></button></NavLink>
        </div>
    </div>
  );
}

export default App;
